import { Box, Flex } from '@chakra-ui/react';
import { DataBoxesContainer } from 'src/components/atoms/DataBoxesContainer';
import { KeyMetricsGrid } from 'src/components/molecules/KeyMetricsGrid';
import { Optimization } from 'src/features/MO/types';
import { DeleteOptimizationButton } from '../../molecules/DeleteOptimizationButton';
import { OptimizationMetricCard } from '../../molecules/OptimizationMetricCard';
import { InvestmentByMediaBarGraph } from '../InvestmentByMediaBarGraph';
import { MediaEffectByMediaBarGraph } from '../MediaEffectByMediaBarGraph';
import { OptimizationDataByMediaTable } from '../OptimizationDataByMediaTable';
import { ROIByMediaBarGraph } from '../ROIByMediaBarGraph';
import { ROMIByMediaBarGraph } from '../ROMIByMediaBarGraph';
// eslint-disable-next-line no-restricted-imports
import { Icon as ChakraIcon } from '@chakra-ui/react';
import { BarChart3, CircleDollarSign, TrendingUp } from 'lucide-react';
import { useKpiUnit } from 'src/hooks/useKpiUnit';

type OptimizationPanelProps = {
  optimization: Optimization;
  isOpen: boolean;
};

export const OptimizationPanel: React.FC<OptimizationPanelProps> = ({
  optimization,
  isOpen,
}) => {
  const { isEuro } = useKpiUnit();
  return (
    <Box>
      <Flex justifyContent="space-between" alignItems="flex-start" gap={4}>
        <Box flex="1">
          <KeyMetricsGrid columns={optimization.totalRomi ? 4 : 3}>
            <OptimizationMetricCard
              name="Investment"
              isEuro
              optimizedValue={optimization.optimizedInvestmentSum}
              initialValue={optimization.initialInvestmentSum}
              icon={
                <ChakraIcon
                  as={CircleDollarSign}
                  boxSize={5}
                  color="gray.500"
                />
              }
            />
            <OptimizationMetricCard
              name="Media effect"
              isEuro={isEuro}
              optimizedValue={optimization.optimizedEffectSum}
              initialValue={optimization.initialEffectSum}
              icon={<ChakraIcon as={TrendingUp} boxSize={5} color="gray.500" />}
            />
            <OptimizationMetricCard
              name="ROI"
              optimizedValue={optimization.totalRoi.optimized}
              initialValue={optimization.totalRoi.initial}
              icon={<ChakraIcon as={BarChart3} boxSize={5} color="gray.500" />}
            />
            {optimization.totalRomi && (
              <OptimizationMetricCard
                name="ROMI"
                optimizedValue={optimization.totalRomi.optimized}
                initialValue={optimization.totalRomi.initial}
                icon={
                  <ChakraIcon as={BarChart3} boxSize={5} color="gray.500" />
                }
              />
            )}
          </KeyMetricsGrid>
        </Box>
        <DeleteOptimizationButton
          optimizationId={optimization.optimizationId}
        />
      </Flex>
      {isOpen && (
        <Box mt="20px">
          <DataBoxesContainer>
            <InvestmentByMediaBarGraph
              colSpan={12}
              title="Investment"
              minH={'250px'}
              optimization={optimization}
            />
            <MediaEffectByMediaBarGraph
              colSpan={12}
              title="Media effect"
              minH={'250px'}
              optimization={optimization}
            />
            {optimization.totalRomi && (
              <ROMIByMediaBarGraph
                colSpan={12}
                title="Return on marketing investment (ROMI)"
                minH={'250px'}
                optimization={optimization}
              />
            )}
            <ROIByMediaBarGraph
              colSpan={12}
              title="Return on investment (ROI)"
              minH={'250px'}
              optimization={optimization}
            />
            <OptimizationDataByMediaTable
              colSpan={12}
              title={`Optimization ${optimization.optimizationName}`}
              optimization={optimization}
            />
          </DataBoxesContainer>
        </Box>
      )}
    </Box>
  );
};
